import React, { useState, useEffect } from 'react';
import '../../../css/huerto/scoringFilter.css';
import { withRouter } from 'react-router-dom';
import ModalFilter from './modalFilter';
import ModalMatriz from './modalMatriz';
import ModalOrdenar from './modalOrdenar';
import ModalAsignacion from './componentAsignacion/modalAsignacion';
import ModalCancelacionesCliente from './ModalCancelacionesCliente';
import ModalCancelacionesPropias from './ModalCancelacionesPropias';
import usePermissions from 'hooks/usePermissions';

/*
props.filterAsignados -> 
0 no aplica filtreo
1 delete -> no asignados
2 delete -> asignados
*/
function ScoringFilters(props) {
    const [modalFilter, setModalFilter] = useState(false);
    const [modalMatriz, setModalMatriz] = useState(false);
    const [modalOrden, setModalOrden] = useState(false);
    const [modalCancelacionesCliente, setModalCancelacionesCliente] = useState(
        false
    );
    const [modalCancelacionesPropias, setModalCancelacionesPropias] = useState(
        false
    );
    const [modalAsignacion, setModalAsignacion] = useState(false);
    const [
        viewdistribucionAsignacion,
        setViewdistribucionAsignacion,
    ] = useState(props.viewdistribucionAsignacion);
    const [matrixData, setMatrixData] = useState(props.matrixData);
    const [contractsSelected, setContractsSelected] = useState(
        inicialStateContractsSelect()
    );
    const [ver_Asignados, setver_Asignados] = useState(
        props.filterAsignados === 1 ? false : true
    );
    const [verNO_Asignados, setverNO_Asignados] = useState(
        props.filterAsignados === 2 ? false : true
    );
    const [orden, setOrden] = useState(props.orden);
    const [contractColors, setContractColors] = useState([]);
    const { checkPermission } = usePermissions();

    useEffect(() => {
        try {
            var colors = props.matrixContracts.split(',');
            var _colorContracts = [];
            colors.forEach(element => {
                if (element !== '') _colorContracts.push('color-' + element);
            });
            setContractColors(_colorContracts);
        } catch {}
        setContractsSelected(inicialStateContractsSelect());
    }, [props.matrixContracts]);

    useEffect(() => {
        setOrden(props.orden);
    }, [props.orden]);

    useEffect(() => {
        props.setViewdistribucionAsignacion(viewdistribucionAsignacion);
    }, [viewdistribucionAsignacion]);

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    useEffect(() => {
        setver_Asignados(true);
        setverNO_Asignados(true);
    }, [props.dealerCodeVWF, props.filtersApplied]);

    useEffect(() => {
        setMatrixData(props.matrixData);
    }, [props.matrixData]);

    useEffect(() => {
        if (!ver_Asignados && !verNO_Asignados) {
            setverNO_Asignados(true);
            props.setFilterAsignados(2);
        } else if (ver_Asignados && verNO_Asignados)
            props.setFilterAsignados(0);
        else if (!ver_Asignados) props.setFilterAsignados(2);
    }, [ver_Asignados]);

    useEffect(() => {
        if (!ver_Asignados && !verNO_Asignados) {
            props.setFilterAsignados(1);
            setver_Asignados(true);
        } else if (ver_Asignados && verNO_Asignados)
            props.setFilterAsignados(0);
        else if (!verNO_Asignados) props.setFilterAsignados(1);
    }, [verNO_Asignados]);

    function inicialStateContractsSelect() {
        if (props.matrixContracts !== '') {
            var contractsSelectType = props.matrixContracts.split(',');
            var Amount = 0;
            contractsSelectType.forEach(element => {
                props.matrixData.forEach(elementAcoont => {
                    if (element === elementAcoont.Category) {
                        Amount += elementAcoont.Amount;
                    }
                });
            });
            return Amount;
        } else return 0;
    }
    const resetFilter = element => {
        if (element && element.target && element.target.parentElement) {
            var filterClassName = element.target.parentElement.className.replace(
                'c-tag c-tag-filter ',
                ''
            );
            filterClassName = filterClassName.split(' ')[0];
            if (filterClassName) {
                if (filterClassName !== 'concesionario') {
                    var newFilters = [];
                    props.filtersApplied.map(e => {
                        if (e.filterName !== filterClassName)
                            newFilters.push(e);
                    });
                    props.setFiltersApplied(newFilters);
                }
            }
        }
    };

    const resetFilter_Producto_comercial = element => {
        element.split(' ').forEach(elementClass => {
            if (
                elementClass === '132' ||
                elementClass === '134' ||
                elementClass === '158' ||
                elementClass === '133' ||
                elementClass === '141'
            ) {
                var newFilters = [];
                props.filtersApplied.map(e => {
                    if (e.filterName !== 'Producto_comercial')
                        newFilters.push(e);
                    else {
                        var stringChange = '';
                        e.value.split(',').forEach(valuedelete => {
                            if (
                                parseInt(elementClass) !== parseInt(valuedelete)
                            )
                                stringChange +=
                                    (stringChange !== '' ? ',' : '') +
                                    parseInt(valuedelete) +
                                    ' ';
                        });
                        if (stringChange !== '' && stringChange !== ' ') {
                            e.value = stringChange;
                            newFilters.push(e);
                        }
                    }
                });
                props.setFiltersApplied(newFilters);
            }
        });
    };
    const renderContractIcons = () => {
        let icons = [];
        for (let i = 0; i < contractColors.length; i++)
            icons.push(
                <span
                    key={i}
                    className={contractColors[i]}
                    style={{ verticalAlign: 'middle' }}
                ></span>
            );

        return (
            <div
                className="contract-circle-div u-float-right u-pl-xsmall"
                style={{ minHeight: '18px' }}
            >
                {icons}
            </div>
        );
    };
    const tagFilter = () => {
        var fecha_venci_desde = '';
        var fecha_venci_hasta = '';
        var matricula = '';
        var bastidor = '';
        var nif = '';
        var fecha_ipo_desde = '';
        var fecha_ipo_hasta = '';
        var Producto_comercial = [];
        var Opefinanciera = '';
        var SellerContractsFullName = '';
        var marca = '';
        var UsuarioVendedorAsignado = '';
        var VehicleModelDescription = '';
        props.filtersApplied.forEach(element => {
            switch (element.filterName) {
                case 'fecha-venci-desde':
                    fecha_venci_desde = element.value;
                    break;
                case 'fecha-venci-hasta':
                    fecha_venci_hasta = element.value;
                    break;
                case 'matricula':
                    matricula = element.value;
                    break;
                case 'bastidor':
                    bastidor = element.value;
                    break;
                case 'nif':
                    nif = element.value;
                    break;
                case 'fecha-ipo-desde':
                    fecha_ipo_desde = element.value;
                    break;
                case 'fecha-ipo-hasta':
                    fecha_ipo_hasta = element.value;
                    break;
                case 'Producto_comercial':
                    let _Producto_comercial = '';
                    element.value.split(',').forEach(_element => {
                        if (_element === '134 ')
                            _Producto_comercial = 'Financiación CPC';
                        else if (_element === '158 ')
                            _Producto_comercial = 'Financiación Next';
                        else if (_element === '132 ')
                            _Producto_comercial = 'Renting';
                        else if (_element === '133 ')
                            _Producto_comercial = 'Financiación Lineal';
                        else if (_element === '141 ')
                            _Producto_comercial = 'Refinanciación CPC';
                        else if (_element === '168 ')
                            _Producto_comercial = 'Refinanciación NEXT';
                        else if (_element === '166 ')
                            _Producto_comercial = 'Financiación Autocredit';

                        Producto_comercial.push(
                            <span
                                className={
                                    'c-tag c-tag-filter Producto_comercial ' +
                                    _element
                                }
                                key={_Producto_comercial}
                            >
                                <span className="c-tag__label">
                                    {_Producto_comercial}
                                </span>
                                <button
                                    className="c-tag__close"
                                    title="Cerrar"
                                    type="button"
                                    onClick={() =>
                                        resetFilter_Producto_comercial(_element)
                                    }
                                ></button>
                            </span>
                        );
                    });
                    break;
                case 'Opefinanciera':
                    Opefinanciera = element.value;
                    break;
                case 'SellerContractsFullName':
                    SellerContractsFullName = element.value;
                    break;
                case 'MarcaSelected':
                    var marcasTags = element.value.split(',');
                    marcasTags.forEach(element => {
                        props.optSelectMarca.forEach(_element => {
                            if (parseInt(element) === parseInt(_element[1]))
                                marca +=
                                    (marca.length > 0 ? ', ' : '') +
                                    _element[0];
                        });
                    });
                    break;
                case 'UsuarioVendedorAsignado':
                    UsuarioVendedorAsignado = element.value;
                    break;
                case 'VehicleModelDescription':
                    VehicleModelDescription = element.value;
                    break;
            }
        });
        return (
            <div className="o-layout scoring-filters-active-div o-layout--equal-height o-layout--flush">
                {contractColors.length > 0 && contractColors.length < 9 && (
                    <span className="c-tag c-tag-filter fecha-venci-hasta">
                        <span className="c-tag__label">
                            Matriz: {renderContractIcons()}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={() => props.setMatrixContracts('')}
                        ></button>
                    </span>
                )}
                {fecha_venci_desde !== '' && (
                    <span className="c-tag c-tag-filter fecha-venci-desde">
                        <span className="c-tag__label">
                            F.V desde: {fecha_venci_desde}{' '}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {fecha_venci_hasta !== '' && (
                    <span className="c-tag c-tag-filter fecha-venci-hasta">
                        <span className="c-tag__label">
                            F.V hasta: {fecha_venci_hasta}{' '}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {matricula !== '' && (
                    <span className="c-tag c-tag-filter matricula">
                        <span className="c-tag__label">
                            Matrícula: {matricula}{' '}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {VehicleModelDescription !== '' && (
                    <span className="c-tag c-tag-filter VehicleModelDescription">
                        <span className="c-tag__label">
                            Modelo: {VehicleModelDescription}{' '}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {bastidor !== '' && (
                    <span className="c-tag c-tag-filter bastidor">
                        <span className="c-tag__label">
                            Bastidor: {bastidor}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {marca !== '' && (
                    <span className="c-tag c-tag-filter MarcaSelected">
                        <span className="c-tag__label">Marca: {marca}</span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {nif !== '' && (
                    <span className="c-tag c-tag-filter nif">
                        <span className="c-tag__label">NIF: {nif} </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {fecha_ipo_desde !== '' && (
                    <span className="c-tag c-tag-filter fecha-ipo-desde">
                        <span className="c-tag__label">
                            F.IPO desde: {fecha_ipo_desde}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {fecha_ipo_hasta !== '' && (
                    <span className="c-tag c-tag-filter fecha-ipo-hasta">
                        <span className="c-tag__label">
                            F.IPO hasta: {fecha_ipo_hasta}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {Opefinanciera !== '' && (
                    <span className="c-tag c-tag-filter Opefinanciera">
                        <span className="c-tag__label">
                            Op Financiera: {Opefinanciera}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {Producto_comercial.length > 0 && (
                    <div>{Producto_comercial}</div>
                )}
                {SellerContractsFullName !== '' && (
                    <span className="c-tag c-tag-filter SellerContractsFullName">
                        <span className="c-tag__label">
                            Asesor original: {SellerContractsFullName}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
                {UsuarioVendedorAsignado !== '' && (
                    <span className="c-tag c-tag-filter UsuarioVendedorAsignado">
                        <span className="c-tag__label">
                            Asesor asignado: {UsuarioVendedorAsignado}
                        </span>
                        <button
                            className="c-tag__close"
                            title="Cerrar"
                            type="button"
                            onClick={resetFilter}
                        ></button>
                    </span>
                )}
            </div>
        );
    };
    const tagOrden = () => {
        if (orden.length !== 2) return <div></div>;
        // type, option
        var text = '';
        switch (orden[1]) {
            case 'SC': //Score/Color Cliente
                text = 'Score C';
                break;
            case 'SV': //Score/Color Vehiculo
                text = 'Score V';
                break;
            case 'PC': // producto comercial
                text = 'Producto C';
                break;
            case 'FV': //fecha de vencimiento
                text = 'Fecha Vnt';
                break;
            case 'FI': //fecha IPO
                text = 'Fecha IPO';
                break;
            case 'AO': //asesor original -> SellerContractsFullName
                text = 'Asesor Org';
                break;
            case 'AA': // asesor asignado -> VendedorAsignado
                text = 'Asesor Asig';
                break;
        }
        return (
            <div className="o-layout scoring-filters-active-div o-layout--equal-height o-layout--flush">
                <span className="c-tag c-tag-filter UsuarioVendedorAsignado">
                    <span className="c-tag__label">
                        Orden: {text}({orden[0]})
                    </span>
                    <button
                        className="c-tag__close"
                        title="Cerrar"
                        type="button"
                        onClick={() => props.setOrden([])}
                    ></button>
                </span>
            </div>
        );
    };

    return (
        <div>
            {props.financialOperationCode == '' &&
            props.financialOperationCodeLPO == '' ? (
                <div className="o-layout">
                    <div className="o-layout__item filterbuttonsContent">
                        <div>
                            <div className="u-float-left">
                                <button
                                    data-tippy-content={
                                        'Accede a la matriz para filtrar por probabilidad de renovación.'
                                    }
                                    data-tippy-placement={''}
                                    className={
                                        'js-tooltip c-btn c-btn--secondary ' +
                                        (props.matrixContracts !== ''
                                            ? 'scoringFiltersBtn-active'
                                            : 'u-text-brand')
                                    }
                                    onClick={() => setModalMatriz(!modalMatriz)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <g
                                            id="Grupo_68433"
                                            data-name="Grupo 68433"
                                            transform="translate(-26.5 -14.5)"
                                        >
                                            <circle
                                                id="Oval-Copy-18"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(26.5 14.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-21"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(26.5 20.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-24"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(26.5 26.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-19"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(32.5 14.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-22"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(32.5 20.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-25"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(32.5 26.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-20"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(38.5 14.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-23"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(38.5 20.5)"
                                                fill="#004666"
                                            />
                                            <circle
                                                id="Oval-Copy-26"
                                                cx="2"
                                                cy="2"
                                                r="2"
                                                transform="translate(38.5 26.5)"
                                                fill="#004666"
                                            />
                                        </g>
                                    </svg>
                                    <span className="mideltextfilter">
                                        MATRIZ
                                    </span>
                                </button>
                            </div>
                            <div className="u-float-left">
                                <button
                                    data-tippy-content={
                                        'Accede a todos los filtros disponibles.'
                                    }
                                    data-tippy-placement={''}
                                    id="butonfilter"
                                    className={
                                        'js-tooltip c-btn c-btn--secondary ' +
                                        (props.filtersApplied.length > 0
                                            ? 'scoringFiltersBtn-active'
                                            : 'u-text-brand')
                                    }
                                    onClick={() => setModalFilter(!modalFilter)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16.5 21"
                                    >
                                        <path
                                            id="Shape"
                                            d="M5.25,1.5h1.5V12H5.25Zm0,18h1.5v3H5.25ZM6,18a2.25,2.25,0,1,1,2.25-2.25A2.25,2.25,0,0,1,6,18Zm0-3a.75.75,0,1,0,.75.75A.75.75,0,0,0,6,15ZM17.25,1.5h1.5V12h-1.5Zm0,18h1.5v3h-1.5ZM18,18a2.25,2.25,0,1,1,2.25-2.25A2.307,2.307,0,0,1,18,18Zm0-3a.75.75,0,1,0,.75.75A.709.709,0,0,0,18,15Zm-6.75-3h1.5V22.5h-1.5Zm0-10.5h1.5v3h-1.5Zm.75,9A2.307,2.307,0,0,1,9.75,8.25a2.25,2.25,0,0,1,4.5,0A2.307,2.307,0,0,1,12,10.5Zm0-3a.709.709,0,0,0-.75.75.75.75,0,0,0,1.5,0A.709.709,0,0,0,12,7.5Z"
                                            transform="translate(-3.75 -1.5)"
                                            fill="#004666"
                                            fillRule="evenodd"
                                        />
                                    </svg>
                                    <span className="mideltextfilter">
                                        FILTROS
                                    </span>
                                </button>
                            </div>
                            <div className="u-float-left">
                                <button
                                    data-tippy-content={
                                        'Ordena el listado de vencimientos.'
                                    }
                                    data-tippy-placement={''}
                                    id="butonfilter"
                                    className={
                                        'js-tooltip c-btn c-btn--secondary ' +
                                        (orden.length === 2
                                            ? 'scoringFiltersBtn-active'
                                            : 'u-text-brand')
                                    }
                                    onClick={() => setModalOrden(!modalOrden)}
                                >
                                    <i className="c-icon c-icon--[control-list-view] c-icon--small" />
                                    <span className="c-btn__text mideltextfilter">
                                        ORDENAR
                                    </span>
                                </button>
                            </div>
                            <div className="u-float-left">
                                <button
                                    data-tippy-content={
                                        'Cancelaciones cliente.'
                                    }
                                    data-tippy-placement={''}
                                    id="butonfilter"
                                    className={
                                        'js-tooltip c-btn c-btn--secondary ' +
                                        (orden.length === 2
                                            ? 'scoringFiltersBtn-active'
                                            : 'u-text-brand')
                                    }
                                    onClick={() =>
                                        setModalCancelacionesCliente(
                                            !modalCancelacionesCliente
                                        )
                                    }
                                >
                                    {/* <i className="c-icon c-icon--[control-list-view] c-icon--small" /> */}
                                    <span className="c-btn__text mideltextfilter">
                                        CANCELACIONES CLIENTE
                                    </span>
                                </button>
                            </div>
                            <div className="u-float-left">
                                <button
                                    data-tippy-content={
                                        'Cancelaciones propias.'
                                    }
                                    data-tippy-placement={''}
                                    id="butonfilter"
                                    //style={{ visibility: 'hidden' }}
                                    className={
                                        'js-tooltip c-btn c-btn--secondary ' +
                                        (orden.length === 2
                                            ? 'scoringFiltersBtn-active'
                                            : 'u-text-brand')
                                    }
                                    onClick={() =>
                                        setModalCancelacionesPropias(
                                            !modalCancelacionesPropias
                                        )
                                    }
                                >
                                    {/* <i className="c-icon c-icon--[control-list-view] c-icon--small" /> */}
                                    <span className="c-btn__text mideltextfilter">
                                        CANCELACIONES PROPIAS
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div className="u-float-right">
                                {checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) && (
                                    <button
                                        className="js-tooltip c-btn c-btn c-btn--secondary u-mr-small"
                                        onClick={() => {
                                            setver_Asignados(!ver_Asignados);
                                        }}
                                        style={
                                            !ver_Asignados
                                                ? { backgroundColor: '#004666' }
                                                : {}
                                        }
                                        data-tippy-content={
                                            'Ver contratos no asignados.'
                                        }
                                        data-tippy-placement={''}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15.887"
                                            height="15.922"
                                            viewBox="0 0 25.887 25.922"
                                        >
                                            <g
                                                data-name="Grupo 9058"
                                                transform="translate(-323.789 -612.767)"
                                            >
                                                <path
                                                    d="M15.61,0a.732.732,0,0,1,.732.732V3.415a.732.732,0,0,1-.732.732h-2.2V9.511h.855A3.293,3.293,0,0,1,17.561,12.8v2.561a.732.732,0,0,1-.732.732H.732A.732.732,0,0,1,0,15.366V12.8A3.293,3.293,0,0,1,3.293,9.512H3.9V4.146H1.463a.732.732,0,0,1-.732-.732V.732A.732.732,0,0,1,1.463,0Z"
                                                    transform="translate(334.975 613.822) rotate(39)"
                                                    fill="none"
                                                    stroke={
                                                        !ver_Asignados
                                                            ? 'white'
                                                            : '#004666'
                                                    }
                                                    strokeWidth="1.5"
                                                    fillRule="evenodd"
                                                />
                                                <path
                                                    d="M2.2.2V7.094a1.1,1.1,0,0,1-2.2,0V0H0Z"
                                                    transform="translate(331.153 630.941) rotate(39)"
                                                    fill={
                                                        !ver_Asignados
                                                            ? 'white'
                                                            : '#004666'
                                                    }
                                                    fillRule="evenodd"
                                                />
                                            </g>
                                            <rect
                                                id="Rectangle"
                                                width="45"
                                                height="2"
                                                transform="rotate(45)"
                                                fill={
                                                    !ver_Asignados
                                                        ? 'white'
                                                        : '#004666'
                                                }
                                                stroke={
                                                    !ver_Asignados
                                                        ? 'white'
                                                        : '#004666'
                                                }
                                                strokeWidth="0.7"
                                            />
                                        </svg>
                                    </button>
                                )}
                                {checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) && (
                                    <button
                                        className="js-tooltip c-btn c-btn c-btn--secondary u-mr-small"
                                        onClick={() => {
                                            setverNO_Asignados(
                                                !verNO_Asignados
                                            );
                                        }}
                                        style={
                                            !verNO_Asignados
                                                ? { backgroundColor: '#004666' }
                                                : {}
                                        }
                                        data-tippy-content={
                                            'Ver contratos asignados.'
                                        }
                                        data-tippy-placement={''}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15.887"
                                            height="15.922"
                                            viewBox="0 0 25.887 25.922"
                                        >
                                            <g
                                                data-name="Grupo 9058"
                                                transform="translate(-323.789 -612.767)"
                                            >
                                                <path
                                                    d="M15.61,0a.732.732,0,0,1,.732.732V3.415a.732.732,0,0,1-.732.732h-2.2V9.511h.855A3.293,3.293,0,0,1,17.561,12.8v2.561a.732.732,0,0,1-.732.732H.732A.732.732,0,0,1,0,15.366V12.8A3.293,3.293,0,0,1,3.293,9.512H3.9V4.146H1.463a.732.732,0,0,1-.732-.732V.732A.732.732,0,0,1,1.463,0Z"
                                                    transform="translate(334.975 613.822) rotate(39)"
                                                    fill="none"
                                                    stroke={
                                                        !verNO_Asignados
                                                            ? 'white'
                                                            : '#004666'
                                                    }
                                                    strokeWidth="1.5"
                                                    fillRule="evenodd"
                                                />
                                                <path
                                                    d="M2.2.2V7.094a1.1,1.1,0,0,1-2.2,0V0H0Z"
                                                    transform="translate(331.153 630.941) rotate(39)"
                                                    fill={
                                                        !verNO_Asignados
                                                            ? 'white'
                                                            : '#004666'
                                                    }
                                                    fillRule="evenodd"
                                                />
                                            </g>
                                        </svg>
                                    </button>
                                )}
                                {checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) && props.user.data.Profile === 12 ? (
                                    <button
                                        className=" c-btn u-text-brand u-mr-small"
                                        onClick={() =>
                                            setModalAsignacion(!modalAsignacion)
                                        }
                                        disabled={
                                            !(
                                                props.listSelectVencimiento
                                                    .length > 0
                                            )
                                        }
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15.887"
                                            height="15.922"
                                            viewBox="0 0 25.887 25.922"
                                        >
                                            <g
                                                id="Grupo_9058"
                                                data-name="Grupo 9058"
                                                transform="translate(-323.789 -612.767)"
                                            >
                                                <path
                                                    id="Combined-Shape"
                                                    d="M15.61,0a.732.732,0,0,1,.732.732V3.415a.732.732,0,0,1-.732.732h-2.2V9.511h.855A3.293,3.293,0,0,1,17.561,12.8v2.561a.732.732,0,0,1-.732.732H.732A.732.732,0,0,1,0,15.366V12.8A3.293,3.293,0,0,1,3.293,9.512H3.9V4.146H1.463a.732.732,0,0,1-.732-.732V.732A.732.732,0,0,1,1.463,0Z"
                                                    transform="translate(334.975 613.822) rotate(39)"
                                                    fill="none"
                                                    stroke="#004666"
                                                    strokeWidth="1.5"
                                                    fillRule="evenodd"
                                                />
                                                <path
                                                    id="Rectangle"
                                                    d="M2.2.2V7.094a1.1,1.1,0,0,1-2.2,0V0H0Z"
                                                    transform="translate(331.153 630.941) rotate(39)"
                                                    fill="#004666"
                                                    fillRule="evenodd"
                                                />
                                            </g>
                                        </svg>
                                        <span className="mideltextfilter">
                                            ASIGNAR
                                        </span>
                                    </button>
                                ) : props.user.data.Profile === 12 ? (
                                    <button
                                        className=" c-btn u-text-brand u-mr-small"
                                        onClick={
                                            () =>
                                                props.aplicarAsignacionVencimiento(
                                                    props.user.data.UserId
                                                ) //dkxewh5
                                        }
                                        disabled={
                                            !(
                                                props.listSelectVencimiento
                                                    .length > 0
                                            )
                                        }
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="15.887"
                                            height="15.922"
                                            viewBox="0 0 25.887 25.922"
                                        >
                                            <g
                                                id="Grupo_9058"
                                                data-name="Grupo 9058"
                                                transform="translate(-323.789 -612.767)"
                                            >
                                                <path
                                                    id="Combined-Shape"
                                                    d="M15.61,0a.732.732,0,0,1,.732.732V3.415a.732.732,0,0,1-.732.732h-2.2V9.511h.855A3.293,3.293,0,0,1,17.561,12.8v2.561a.732.732,0,0,1-.732.732H.732A.732.732,0,0,1,0,15.366V12.8A3.293,3.293,0,0,1,3.293,9.512H3.9V4.146H1.463a.732.732,0,0,1-.732-.732V.732A.732.732,0,0,1,1.463,0Z"
                                                    transform="translate(334.975 613.822) rotate(39)"
                                                    fill="none"
                                                    stroke="#004666"
                                                    strokeWidth="1.5"
                                                    fillRule="evenodd"
                                                />
                                                <path
                                                    id="Rectangle"
                                                    d="M2.2.2V7.094a1.1,1.1,0,0,1-2.2,0V0H0Z"
                                                    transform="translate(331.153 630.941) rotate(39)"
                                                    fill="#004666"
                                                    fillRule="evenodd"
                                                />
                                            </g>
                                        </svg>
                                        <span className="mideltextfilter">
                                            AUTOASIGNAR
                                        </span>
                                    </button>
                                ) : (
                                    <div />
                                )}

                                {checkPermission(
                                    'CNST_ASIGNACION_VOLUMEN_VENDEDOR'
                                ) &&
                                    props.user.data.Profile === 12 && (
                                        <button
                                            className=" c-btn c-btn--secondary u-mr-small"
                                            onClick={() =>
                                                setViewdistribucionAsignacion(
                                                    !viewdistribucionAsignacion
                                                )
                                            }
                                            style={
                                                !viewdistribucionAsignacion
                                                    ? {
                                                          backgroundColor:
                                                              'white',
                                                          color: '#004666',
                                                      }
                                                    : {
                                                          color: 'white',
                                                          background: '#004666',
                                                      }
                                            }
                                        >
                                            <span className="mideltextfilter">
                                                {viewdistribucionAsignacion
                                                    ? 'VER LISTADO COMPLETO'
                                                    : 'DISTRIBUCION ASIG'}
                                            </span>
                                        </button>
                                    )}
                                {props.user.data.Profile === 12 && (
                                    <button
                                        className="c-btn"
                                        onClick={() =>
                                            props.setViewDataVencimientoAsignado(
                                                false
                                            )
                                        }
                                    >
                                        <span className="mideltextfilter">
                                            VER MIS ASIGNADOS
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}

            {modalFilter && (
                <ModalFilter
                    setModalFilter={setModalFilter}
                    setFiltersApplied={props.setFiltersApplied}
                    filtersApplied={props.filtersApplied}
                    optSelectMarca={props.optSelectMarca}
                />
            )}
            {modalMatriz && (
                <ModalMatriz
                    setModalMatriz={setModalMatriz}
                    matrixData={matrixData}
                    setMatrixContracts={props.setMatrixContracts}
                    matrixContractsColor={props.matrixContracts}
                    contractsSelected={contractsSelected}
                    setContractsSelected={setContractsSelected}
                    data={props.data}
                />
            )}
            {modalAsignacion && (
                <ModalAsignacion
                    setModalAsignacion={setModalAsignacion}
                    listSelectVencimiento={props.listSelectVencimiento}
                    aplicarAsignacionVencimiento={
                        props.aplicarAsignacionVencimiento
                    }
                    listPerfilesAsignacionVolumenVendedor={
                        props.listPerfilesAsignacionVolumenVendedor
                    }
                />
            )}
            {modalOrden && (
                <ModalOrdenar
                    setModalorden={setModalOrden}
                    setOrden={props.setOrden}
                    orden={props.orden}
                    viewDisplay={'ListadoCompleto'}
                />
            )}

            {modalCancelacionesCliente && (
                <ModalCancelacionesCliente
                    setModalCancelacionesCliente={setModalCancelacionesCliente}
                    dealerCodeVWF={props.dealerCodeVWF}
                    cookies={props.cookies}
                    setFinancialOperationCode={props.setFinancialOperationCode}
                />
            )}
            {modalCancelacionesPropias && (
                <ModalCancelacionesPropias
                    setModalCancelacionesPropias={setModalCancelacionesPropias}
                    dealerCodeVWF={props.dealerCodeVWF}
                    cookies={props.cookies}
                    setFinancialOperationCodeLPO={
                        props.setFinancialOperationCodeLPO
                    }
                />
            )}
            <div>
                {(props.filtersApplied.length > 0 ||
                    (contractColors.length > 0 && contractColors.length < 9)) &&
                    tagFilter()}
            </div>
            <div>{tagOrden()}</div>
        </div>
    );
}
export default withRouter(ScoringFilters);
